import { createAsyncThunk } from '@reduxjs/toolkit';
import { fmDashboardService } from '../../../services/financeManagement/dashboard.service';
import { showHideLoader } from '../../common/common.slice';


// Get all invoices list action
const getAllInvoicesListingAction = createAsyncThunk('fmProjectsSlice/getAllInvoicesListingAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    return fmDashboardService.getAllInvoiceListing({payload})
        .then((response: any) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get cash flow listing action
const getCashFlowListingAction = createAsyncThunk('fmDashboardSlice/getCashFlowListingAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    
    return fmDashboardService.getCashFlowListing({payload})
        .then((response: any) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get account payable listing action (same endpoint as cash flow)
const getAccountPayableListingAction = createAsyncThunk('fmDashboardSlice/getAccountPayableListingAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    return fmDashboardService.getAccountPayableListing({payload})
        .then((response: any) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

const exportAccountPayableCsvAction = createAsyncThunk(
    'fmDashboardSlice/exportAccountPayableCsvAction',
    async (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return fmDashboardService
            .exportAccountPayableCsvService({ payload })
            .then((response: any) => {
                setTimeout(() => dispatch(showHideLoader(false)), 500);
                return response;
            })
            .catch((error: { response: unknown }) => {
                setTimeout(() => dispatch(showHideLoader(false)), 500);
                return rejectWithValue(error?.response);
            });
    }
);

// Export all Projects Action
export const fmDashboardActions = {
    getAllInvoicesListingAction,
    getCashFlowListingAction,
    getAccountPayableListingAction,
    exportAccountPayableCsvAction,
}